import { useDispatch } from 'react-redux';
import { authActions } from '../redux/reducers/auth-slice';
import { axiosFetch } from '../utils/apiUtils';
import { useNavigate } from 'react-router-dom';

const useRefreshToken = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const refresh = async () => {
        try {
            const response = await axiosFetch.get('accounts/token/refresh/', {
                withCredentials: true,
            });
            const { data } = response.data;
            dispatch(authActions.grantLoginAccess({
                accessToken: data.access_token,
                user: { ...data.user, wallet_amount: response.data.data.wallet_amount },
                isLoggedIn: true
            }));
            return data.access_token;
        } catch (err) {
            console.error("🚀 ~ file: use-refresh-token.js:21 ~ refresh ~ err:", err)
            dispatch(authActions.removeLoginAccess());
            localStorage.removeItem('user');
            navigate('/accounts/signin');
        }
    }
    return refresh;
}

export default useRefreshToken;